import { HSLColor } from '@yola/yola-palette-generator';
import increaseColorPointByStep from '../../../../../common/utils/increase-color-point-by-step';
import reduceColorPointByStep from '../../../../../common/utils/reduce-color-point-by-step';

const dark = (params, isAccentBackground = false) => {
  const { targetColor, backgroundColor, targetColorPalette, whiteColor, blackColor } = params;
  const fallback = {
    rule: 'secondaryButton.brandedSolid.background.hover.dark',
    params,
  };
  if (targetColor.equals(targetColorPalette[900])) {
    return targetColorPalette[800];
  }

  if (targetColor.equals(whiteColor)) {
    return targetColorPalette[50];
  }

  if (targetColor.equals(targetColorPalette[50])) {
    const { hue, saturation, lightness, alpha } = targetColor;
    const colorInstance = new HSLColor(hue, saturation, lightness, alpha);
    colorInstance.setAlpha(0.4);
    return colorInstance;
  }

  if (targetColor.equals(blackColor)) {
    return targetColorPalette[900];
  }

  const increasedTargetColor = increaseColorPointByStep({
    targetColor,
    targetColorPalette,
    step: 1,
    fallback,
  });
  const reducedTargetColor = reduceColorPointByStep({
    targetColor,
    targetColorPalette,
    step: 1,
    fallback,
  });

  if (
    (isAccentBackground && reducedTargetColor.equals(backgroundColor)) ||
    increasedTargetColor.equals(backgroundColor)
  ) {
    const { hue, saturation, lightness, alpha } = targetColor;
    const colorInstance = new HSLColor(hue, saturation, lightness, alpha);
    colorInstance.setAlpha(0.4);
    return colorInstance;
  }

  return reducedTargetColor;
};

export default dark;
